<template>
  <div>
    <!--    TEXT   -->
    <div class="TEXT" v-if="scenarioContent.subType === 'TEXT'">
      <div class="title" v-if="scenarioContent.title">{{ scenarioContent.title }}</div>
      <div class="txt message-content-wrap">{{ scenarioContent.description }}</div>
      <p class="txt" :style="{ paddingTop: scenarioContent.buttons ? '5px' : '0' }" v-html="scenarioContent.text"></p>
      <div v-if="scenarioContent.buttons && !isBubble">
        <ButtonContents
          :messageType="messageType"
          :chatIndex="chatIndex"
          :scenarioData="scenarioData"
          :clickedCategory="clickedCategory"
          :chatButtons="scenarioContent.buttons"
          :chat="chat"
        />
      </div>
      <div v-show="hasCounselorButton(scenarioContent.buttons).length > 0 && !isBubble">
        <CounselorButtons :counselorButtons="scenarioContent.buttons" :messageType="messageType" :clickedCategory="clickedCategory" :chat="chat" />
      </div>
    </div>

    <!--    'LIST_TEXT', 'LIST', 'IMAGE_LIST_TEXT', 'IMAGE', 'IMAGE_TEXT' , 'IMAGE_LIST'-->
    <div class="IMAGE_LIST_TEXT" v-if="checkSubType(scenarioContent.subType)">
      <div class="image" v-if="scenarioContent.url">
        <img :src="scenarioContent.url" />
      </div>
      <div class="listBox">
        <ul>
          <li v-for="(item, idx) in scenarioContent.lists" :key="idx">
            <dl>
              <dt>{{ item.title }}</dt>
              <dd class="txt message-content-wrap">{{ item.description }}</dd>
              <dd class="img">
                <img :src="item.image.url" />
              </dd>
            </dl>
            <div v-if="item.button.text.trim() !== ''" :class="{ listBtns: !isBubble, BubbleListBtn: isBubble }">
              <a
                :href="item.button.url"
                target="_blank"
                :style="{
                  color: isRoundCustom ? '#3f5710' : '#2645b6',
                  'background-color': isRoundCustom ? '#fdfff4' : '#fafaff',
                  'border-color': isRoundCustom ? '#d1d1d1' : '#2645b6'
                }"
              >
                {{ item.button.text }}
                <i v-if="!isBubble" class="UXicon-arrow_right"></i>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="msgContBox">
        <div class="title" v-if="scenarioContent.title">{{ scenarioContent.title }}</div>
        <p class="txt message-content-wrap">{{ scenarioContent.description }}</p>
        <div v-if="scenarioContent.buttons && !isBubble">
          <ButtonContents
            :messageType="messageType"
            :chatIndex="chatIndex"
            :scenarioData="scenarioData"
            :clickedCategory="clickedCategory"
            :chatButtons="scenarioContent.buttons"
            :chat="chat"
          />
        </div>
      </div>
      <div v-show="hasCounselorButton(scenarioContent.buttons).length > 0 && !isBubble">
        <CounselorButtons :counselorButtons="scenarioContent.buttons" :messageType="messageType" :clickedCategory="clickedCategory" :chat="chat" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonContents from './ButtonContents';
import CounselorButtons from './CounselorButtons';
import { mapGetters } from 'vuex';
import { getHectoRoundList } from '@/constants/customInfo';

export default {
  name: 'ScenarioList',
  props: ['chatIndex', 'chat', 'clickedCategory', 'scenarioData', 'isBubble'],
  components: {
    ButtonContents,
    CounselorButtons
  },
  computed: {
    ...mapGetters(['getBrandId']),
    isRoundCustom() {
      return getHectoRoundList().brands.includes(this.getBrandId);
    }
  },
  created() {
    this.scenarioContent = JSON.parse(this.chat.content);
  },
  data() {
    return {
      scenarioContent: [],
      messageType: 'SCENARIO',
      subType: ['LIST_TEXT', 'LIST', 'IMAGE_LIST_TEXT', 'IMAGE', 'IMAGE_TEXT', 'IMAGE_LIST']
    };
  },
  methods: {
    checkSubType(type) {
      return this.subType.indexOf(type) > -1;
    },
    hasCounselorButton(buttons) {
      return buttons.filter((b) => b.type === 'COUNSELOR_BUTTON');
    }
  }
};
</script>

<style scoped>
.message-content-wrap {
  white-space: pre-line;
  word-break: break-all;
}

.BubbleListBtn {
  display: flex;
  width: 260px;
  height: 40px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 50px;
  border: 1px solid var(--webchat-chatbox-font, #2645b6);
  background: #fff;
}
</style>
